(function () {
  if (window.__mcComplInit) return;
  window.__mcComplInit = true;

  function step(track) {
    var card = track.querySelector('.mc-compl__card');
    if (!card) return track.clientWidth * 0.8;
    var gap =
      parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '14') || 14;
    return card.getBoundingClientRect().width + gap;
  }
  function update(root) {
    var track = root.querySelector('.mc-compl__track');
    var nav = root.querySelector('[data-mc-compl-nav]');
    if (!track || !nav) return;
    var overflow = track.scrollWidth - track.clientWidth > 4;

    nav.hidden = !overflow || track.clientWidth === 0;
    if (nav.hidden) return;
    var prev = root.querySelector('[data-mc-compl-prev]');
    var next = root.querySelector('[data-mc-compl-next]');
    var x = track.scrollLeft;
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = x <= 2;
    if (next) next.disabled = x >= max;
  }
  function setup(root) {
    var track = root.querySelector('.mc-compl__track');
    if (!track || root.__mcBound) {
      update(root);
      return;
    }
    root.__mcBound = true;
    root.addEventListener('click', function (e) {
      var p = e.target.closest('[data-mc-compl-prev]');
      var n = e.target.closest('[data-mc-compl-next]');
      if (!p && !n) return;
      track.scrollBy({ left: (n ? 1 : -1) * step(track), behavior: 'smooth' });
    });
    track.addEventListener(
      'scroll',
      function () {
        window.requestAnimationFrame(function () {
          update(root);
        });
      },
      { passive: true },
    );
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        update(root);
      }).observe(track);
    }
    update(root);
  }
  function initAll() {
    document.querySelectorAll('[data-mc-compl]').forEach(setup);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener(
    'resize',
    function () {
      document.querySelectorAll('[data-mc-compl]').forEach(update);
    },
    { passive: true },
  );
})();
